import { render } from "./EditBudgetEntryModal.vue?vue&type=template&id=63579935&ts=true"
import script from "./EditBudgetEntryModal.vue?vue&type=script&lang=ts"
export * from "./EditBudgetEntryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__